import {createContext as $5e4iu$createContext} from "react";
import {StatefulComponent as $5e4iu$StatefulComponent} from "@macrostrat/ui-components";
import $5e4iu$macrostrathyper from "@macrostrat/hyper";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $dd006942bf7b8226$exports = {};

$parcel$export($dd006942bf7b8226$exports, "FaciesContext", () => $dd006942bf7b8226$export$d35e93c5fa5279ad);
$parcel$export($dd006942bf7b8226$exports, "FaciesProvider", () => $dd006942bf7b8226$export$d3920cb1140b6284);



const $dd006942bf7b8226$export$d35e93c5fa5279ad = (0, $5e4iu$createContext)({
    facies: [],
    onColorChanged () {}
});
class $dd006942bf7b8226$export$d3920cb1140b6284 extends (0, $5e4iu$StatefulComponent) {
    constructor(props){
        super(props);
        this.state = {
            facies: props.initialFacies || [],
            __colorMap: {}
        };
        this.getFaciesColor = this.getFaciesColor.bind(this);
        this.setFaciesColor = this.setFaciesColor.bind(this);
    }
    getFaciesColor(id) {
        const { __colorMap: __colorMap } = this.state;
        return __colorMap[id] || null;
    }
    setFaciesColor(id, color) {
        const ix = this.state.facies.findIndex((d)=>d.id === id);
        return this.updateState({
            facies: {
                [ix]: {
                    color: {
                        $set: color
                    }
                }
            }
        });
    }
    render() {
        const { facies: facies } = this.state;
        const { children: children, ...rest } = this.props;
        const procedures = (()=>{
            let getFaciesColor, setFaciesColor;
            return { getFaciesColor: getFaciesColor, setFaciesColor: setFaciesColor } = this;
        })();
        const value = {
            facies: facies,
            ...procedures,
            ...rest
        };
        return (0, $5e4iu$macrostrathyper)($dd006942bf7b8226$export$d35e93c5fa5279ad.Provider, {
            value: value
        }, children);
    }
}


export {$dd006942bf7b8226$export$d35e93c5fa5279ad as FaciesContext, $dd006942bf7b8226$export$d3920cb1140b6284 as FaciesProvider};
//# sourceMappingURL=column-components.ac3ed2cd.js.map
